module.exports = __webpack_public_path__ + "img/icon_fire.04d5d0c2.png";